import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import LoginFooter from './components/LoginFooter';

const AdminLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const authData = localStorage.getItem('nfc_admin_auth');
    if (authData) {
      try {
        const auth = JSON.parse(authData);
        const loginTime = new Date(auth.loginTime);
        const currentTime = new Date();
        const timeDifference = currentTime - loginTime;
        const hoursElapsed = timeDifference / (1000 * 60 * 60);

        // Check if session is still valid (8 hours)
        if (hoursElapsed < 8) {
          navigate('/dashboard');
          return;
        } else {
          // Session expired, remove auth data
          localStorage.removeItem('nfc_admin_auth');
        }
      } catch (error) {
        // Invalid auth data, remove it
        localStorage.removeItem('nfc_admin_auth');
      }
    }

    // Set page title
    document.title = 'Admin Login - NFC Card Admin';
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-secondary opacity-50"></div>
      
      {/* Login Container */}
      <div className="relative w-full max-w-lg mx-auto">
        <div className="bg-surface border border-border rounded-2xl shadow-elevation-3 p-8 lg:p-12">
          {/* Login Header */}
          <LoginHeader />
          
          {/* Login Form */}
          <LoginForm />
          
          {/* Login Footer */}
          <LoginFooter />
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-accent/10 rounded-full blur-xl"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-accent/5 rounded-full blur-2xl"></div>
      <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-accent/5 rounded-full blur-lg"></div>
    </div>
  );
};

export default AdminLogin;